import * as React from 'react';

import { DataProxy } from 'apollo-cache';
import { Mutation, MutationResult, Query } from 'react-apollo';
import { InjectedRouter } from 'react-router';

import ErrorReporter from 'app/components/ErrorReporter';
import { withRouter } from 'app/context/Router';
import LoadingIndicator from 'components/LoadingIndicator';

import AdminDistrictSisDashboard from 'admin/rostering/components/AdminDistrictSisDashboard';

import ADMIN_DISTRICT_SIS_DASHBOARD_QUERY from 'admin/rostering/queries/AdminDistrictSisDashboardQuery.gql';
import SET_ROSTERING_ENFORCEMENT from 'admin/rostering/mutations/SetRosteringEnforcementMutation.gql';

import { AdminDistrictSisDashboard as AdminDistrictSisDashboardQuery } from 'admin/rostering/queries/__generated__/AdminDistrictSisDashboard';
import {
  setRosteringEnforcement as setRosteringEnforcementResult,
  setRosteringEnforcementVariables,
} from 'admin/rostering/mutations/__generated__/setRosteringEnforcement';

type Props = {
  router: InjectedRouter;
  orgId: number;
  syncMethod: string;
};

class AdminDistrictSisDashboardContainer extends React.Component<Props> {
  render() {
    const queryVars = { organizationId: this.props.orgId };
    return (
      <Mutation<setRosteringEnforcementResult>
        mutation={SET_ROSTERING_ENFORCEMENT}
        update={(cache: DataProxy, { data }) => {
          const { organizations } = cache.readQuery({
            query: ADMIN_DISTRICT_SIS_DASHBOARD_QUERY,
            variables: queryVars,
          }) as AdminDistrictSisDashboardQuery;
          const organization = organizations[0];
          if (!organization || !data) {
            return;
          }
          cache.writeQuery({
            query: ADMIN_DISTRICT_SIS_DASHBOARD_QUERY,
            variables: queryVars,
            data: {
              organizations: [
                {
                  ...organization,
                  permissions: {
                    canRosteredUsersLeaveOrg: data.setRosteringEnforcement.allowedToLeave,
                    __typename: 'OrganizationPermissions',
                  },
                },
              ],
            },
          });
        }}>
        {(
          setRosteringEnforcement: (input: { variables: setRosteringEnforcementVariables }) => void
        ) => {
          return (
            <Query<AdminDistrictSisDashboardQuery>
              query={ADMIN_DISTRICT_SIS_DASHBOARD_QUERY}
              variables={queryVars}>
              {({ loading, error, data }) => {
                if (loading) {
                  return <LoadingIndicator height={400} size="small" />;
                }

                if (error || !data || !data.organizations) {
                  return (
                    <ErrorReporter error="AdminDistrictSisDashboardContainer - could not load district" />
                  );
                }

                const organization = data.organizations[0];
                if (!organization) {
                  return (
                    <ErrorReporter error="AdminDistrictSisDashboardContainer - could not load district" />
                  );
                }

                const toggleChangeRosteringEnforcement = (allowedToLeave: boolean) => {
                  setRosteringEnforcement({
                    variables: { input: { orgUuid: organization.uuid, allowedToLeave } },
                  });
                };

                return (
                  <AdminDistrictSisDashboard
                    organization={organization}
                    orgId={this.props.orgId}
                    syncMethod={this.props.syncMethod}
                    router={this.props.router}
                    handleRosteringEnforcementChange={toggleChangeRosteringEnforcement}
                  />
                );
              }}
            </Query>
          );
        }}
      </Mutation>
    );
  }
}

export { AdminDistrictSisDashboardContainer };
export default withRouter(AdminDistrictSisDashboardContainer);
